import { createTrackingUtils } from "..";
import useProfiler from "../../../hooks/useProfiler";
import { type UIPriceBreakdown } from "@flights/types";
import useUserAgent from "../../../hooks/useUserAgent";
import { useSelector } from "react-redux";
import { getGeniusLevel } from "../../../store/user/selectors";

const utils = createTrackingUtils({
  name: "flights_genius_merch_blockout",
  stages: {
    genius_users_sr_fd_offer_available: 1,
    ddot: 2,
    mdot: 3,
    ios: 4,
    android: 5,
    genius_level_one: 6,
    genius_level_two: 7,
    genius_level_three: 8,
    fd_with_genius_offer: 9
  },
  defaultStage: 1,
  goals: {}
});

export const useGeniusMerchBlockout = () => {
  const { isLoggedIn } = useProfiler();
  if (!isLoggedIn()) return false;
  else return utils.trackWithDefaultStage() > 0;
};

export const useGeniusMerchBlockoutExperiment = ({
  bcomPricingItems,
  isFlightDetails = false
}: {
  bcomPricingItems?: UIPriceBreakdown["bcomPricingItems"];
  isFlightDetails?: boolean;
}) => {
  const { isMobile } = useUserAgent();
  const geniusLevel = useSelector(getGeniusLevel);
  const { isLoggedIn } = useProfiler();

  if (!isLoggedIn()) {
    return false;
  }

  const hasGeniusFareDiscount = bcomPricingItems?.some(
    (item) => item.itemType === "GENIUS_DEAL" || item.itemType === "GENIUS_AIRLINE_FARE"
  );

  if (!hasGeniusFareDiscount) {
    return false;
  }

  const inVariant = utils.trackWithDefaultStage() > 0;

  if (isMobile) utils.stages.mdot();
  else utils.stages.ddot();

  if (geniusLevel === 1) {
    utils.stages.genius_level_one();
  } else if (geniusLevel === 2) {
    utils.stages.genius_level_two();
  } else if (geniusLevel === 3) {
    utils.stages.genius_level_three();
  }

  if (isFlightDetails) {
    utils.stages.fd_with_genius_offer();
  }

  return inVariant;
};
